import VerticalPressimg from '../assets/images/pressmenu.png';
import VerticalPressimgGE from '../assets/images/pressmenuGE.png';

import Oscyllisimg from '../assets/images/Oscyllismenu.png';
import OscyllisimgGE from '../assets/images/OscyllismenuGE.png';

import ProductItemImg from '../assets/images/Pumpmenu.png';
import ProductItemImgGE from '../assets/images/PumpmenuGE.png';

import TanksBarriquesAnforaImg from '../assets/images/anforamenu.png';
import TanksBarriquesAnforaImgGE from '../assets/images/anforamenuGE.png';

import FilterImg from '../assets/images/filtermenu.png';
import FilterImgGE from '../assets/images/filtermenuGE.png';

import BotlingLabelingImg from '../assets/images/BotlingLabelingmenu.png';
import BotlingLabelingImgGE from '../assets/images/BotlingLabelingmenuGE.png';

import ReceptionImg from '../assets/images/Receptionmenu.png';
import ReceptionImgGE from '../assets/images/ReceptionmenuGE.png';

import CoolingUnitImg from '../assets/images/cooler&heatermenu.png';
import CoolingUnitImgGE from '../assets/images/cooler&heatermenuGE.png';

import DestillerImg from '../assets/images/Destillermenu.png';
import DestillerImgGE from '../assets/images/DestillermenuGE.png';

import FruitEquipmentImg from '../assets/images/FruitEquipmentmenu.png';
import FruitEquipmentImgGE from '../assets/images/FruitEquipmentmenuGE.png';

import SorterImg from '../assets/images/sortermenu.png';
import SorterImgGE from '../assets/images/sortermenuGE.png';

import GardeningAndVineyardImg from '../assets/images/GardeningandVineyeardmenu.png';
import GardeningAndVineyardImgGE from '../assets/images/GardeningandVineyeardmenuGE.png';

import WineDispenserComponentImg from '../assets/images/winedispensermenu.png';
import WineDispenserComponentImgGE from '../assets/images/winedispensermenuGE.png';

import FittingsTubesImg from '../assets/images/Tubes.png';
import FittingsTubesImgGE from '../assets/images/TubesGE.png';

import SmallEquipmentsImg from '../assets/images/smallequipmentsmenu.png';
import SmallEquipmentsImgGE from '../assets/images/smallequipmentsmenuGE.png';

import UsedEquipmentsImg from '../assets/images/usedequipment.png';
import UsedEquipmentsImgGE from '../assets/images/usedequipmentGE.png';

export const Productimg = [
  { id: 1, name: 'Press', images: { en: VerticalPressimg, ka: VerticalPressimgGE } },
  { id: 2, name: 'Destemmer Crusher', images: { en: Oscyllisimg, ka: OscyllisimgGE } },
  { id: 3, name: 'Pump', images: { en: ProductItemImg, ka: ProductItemImgGE } },
  { id: 4, name: 'Tanks Barriques Anfora', images: { en: TanksBarriquesAnforaImg, ka: TanksBarriquesAnforaImgGE } },
  { id: 5, name: 'Filter', images: { en: FilterImg, ka: FilterImgGE } },
  { id: 6, name: 'Botling Labeling', images: { en: BotlingLabelingImg, ka: BotlingLabelingImgGE } },
  { id: 7, name: 'Reception', images: { en: ReceptionImg, ka: ReceptionImgGE } },
  { id: 8, name: 'Cooler & Heater', images: { en: CoolingUnitImg, ka: CoolingUnitImgGE } },
  { id: 9, name: 'Destiller', images: { en: DestillerImg, ka: DestillerImgGE } },
  { id: 10, name: 'Fruit Equipment', images: { en: FruitEquipmentImg, ka: FruitEquipmentImgGE } },
  { id: 11, name: 'Sorter', images: { en: SorterImg, ka: SorterImgGE } },
  { id: 12, name: 'Gardening and Vineyard', images: { en: GardeningAndVineyardImg, ka: GardeningAndVineyardImgGE } },
  { id: 13, name: 'Wine Dispenser', images: { en: WineDispenserComponentImg, ka: WineDispenserComponentImgGE } },
  { id: 14, name: 'Fittings Tubes', images: { en: FittingsTubesImg, ka: FittingsTubesImgGE } },
  { id: 15, name: 'Small Equipments', images: { en: SmallEquipmentsImg, ka: SmallEquipmentsImgGE } },
  { id: 16, name: 'Used Equipments', images: { en: UsedEquipmentsImg, ka: UsedEquipmentsImgGE } },
];